module.exports = __webpack_public_path__ + "static/02-2cb6bdeec913d166404c131801a3ff11.jpg";